import React, { useEffect, useState } from 'react';
import { Translation } from 'react-i18next';
import openNotification from './Notification/Notificaiton'

const AlertBox = ({ apiBuilderLocal, settingPaginationTotal }) => {
  const [alertHide, setAlertHide] = useState(true);

  useEffect(() => {
    if (apiBuilderLocal.actualTotal > settingPaginationTotal &&
        apiBuilderLocal.pagination.current === 1) {
      openNotification({
        type: 'success',
        message: <Translation>{(t) => t('ALERT')}</Translation>,
        description: <Translation>{(t) => t('API_LIMIT_WARNING', { count: settingPaginationTotal })}</Translation>
      });
    }
  }, [apiBuilderLocal.actualTotal, settingPaginationTotal, apiBuilderLocal.pagination.current]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Tab') {
        console.log(e.key, 'Key');
        setAlertHide(false);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return <div>{!alertHide && <p>Alert Message!</p>}</div>;
};

export default AlertBox;



// WEBPACK FOOTER //
// src/components/AlertBox.jsx